import AxiosConfig from './LensAxiosConfig'
import firebase from '../config/FirebaseConfig'
import { createQuery } from '../../utils/filterUtils'
import { providerKeyMap } from '@/utils/lens/dataSourceUtils'
import axios from 'axios'
import moment from 'moment'

let statusSearchCancelToken = null
let insightsCancelToken = null

const create = async (lensPayload) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/lenses',
    lensPayload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
  return data
}

const getAll = async (query) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser
  const params = new URLSearchParams()

  if (query?.page) params.append('page', query.page)
  if (query?.limit) params.append('limit', query.limit)

  const { data } = await AxiosConfig.get(
    `/lenses?${params.toString()}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getAllSidebar = async () => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    '/folders',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const get = async (id) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    `/lenses/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getPublic = async (id) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
      `/lenses/${id}/public`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
  )

  return data
}

const update = async (id, updatePayload) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.patch(
    `/lenses/${id}`,
    updatePayload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getFBAccountsList = async () => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get('/connections/fb-accounts', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const getPlatformAccounts = async () => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get('/oauth/providers', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const getAllAdAccounts = async () => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get('/oauth/advertisers', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const getPlatformAuthURL = async (platform) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(`/oauth/${platform}/url`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data.data
}

const getLensConnections = async () => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get('/connections/lens', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}
const createTWAccount = async (currency, timezone) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/tw',
    {
      currency,
      timezone
    },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getTWAccounts = async () => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    '/tw',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getTWAccountsList = async () => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    '/tw/accounts',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getAccountStatus = async () => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    '/tw/accounts/status',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getTWSignInURL = async () => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    '/connections/tw/iframe',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getTWRedirect = async (internalTwAccountId) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    '/tw/redirect?internal_tw_account_id=' + internalTwAccountId,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const deleteLens = async (id) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.delete(
    `/lenses/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getLensStatus = async (lensId, dateRange = null) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(`/lenses/${lensId}/status`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: dateRange ? {
      start_date: dateRange.start,
      end_date: dateRange.end
    } : {}
  })

  return data
}

const getLensStatusV2 = async (lensId, dateRange = null) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(`/lenses/${lensId}/status-v2`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: dateRange ? {
      start_date: dateRange.start,
      end_date: dateRange.end
    } : {}
  })

  return data
}

const abortStatusSearchRequest = () => {
  if (statusSearchCancelToken) {
    statusSearchCancelToken.cancel('Status search request cancelled by user.')
  }
}

const getAllLensStatusV2 = async (query) => {
  const { Aa: token } = firebase.auth().currentUser
  const {
    dateRange = {
      start: moment().subtract(364, 'days').startOf('day').format('YYYY-MM-DD'),
      end: moment().endOf('day').format('YYYY-MM-DD')
    },
    page = null,
    limit = null,
    search = null
  } = query || {}

  // Cancel the previous request if it exists
  if (statusSearchCancelToken) {
    statusSearchCancelToken.cancel('New request incoming, cancelling previous one.')
  }

  statusSearchCancelToken = axios.CancelToken.source()

  const { data } = await AxiosConfig.get('/lenses/status-v2', {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: {
      ...(dateRange && { start_date: dateRange.start, end_date: dateRange.end }),
      ...(search && { q: search }),
      ...(page && { page }),
      ...(limit && { limit })
    }
  })

  return data
}

const getLensDiscoveryAds = async (lensId, nextId, filters) => {
  const { Aa: token } = firebase.auth().currentUser

  const params = {
    // Create the filters
    ...createQuery(filters),
    next: nextId
  }

  const { data } = await AxiosConfig.get(`/lenses/${lensId}/discovery`, {
    params,
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const getInsightByLens = async (lensId, properties) => {
  const { Aa: token } = firebase.auth().currentUser
  const { adAccountIds = null, dateQuery = null, attrWindow = null, platform = 'meta', allowCancel = false } = properties

  if (allowCancel) {
    if (insightsCancelToken) {
      insightsCancelToken.cancel('New request incoming, cancelling previous one.')
    }
    insightsCancelToken = axios.CancelToken.source()
  }

  const payload = {
    query: [
      ...(adAccountIds ? [[{ key: 'account_id', operation: 'in', value: adAccountIds }]] : []),
      ...(dateQuery ?? [
        [{ key: 'event_date', operation: 'greater_than', value: 'last_7_days' }],
        [{ key: 'event_date', operation: 'less_than', value: 'today' }]
      ])
    ],
    metadata: {
      provider: providerKeyMap[platform],
      attr_window: attrWindow ?? { click: '7d', view: '1d' },
      group_by: 'creative',
      page: 1,
      limit: 10
    }
  }

  const { data } = await AxiosConfig.post(
    `/ads/insights/${lensId}`,
    payload,
    {
      ...(allowCancel && { cancelToken: insightsCancelToken.token }),
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
  return data
}

// ============== Lens lighthouse ============== \\

const createLighthouseConfig = async (lensId, payload) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    `/lenses/${lensId}/lighthouse/configurations`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const updateLighthouseConfig = async (lensId, configId, payload) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.patch(
    `/lenses/${lensId}/lighthouse/configurations/${configId}`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getLensLighthouseConfig = async (lensId) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    `/lenses/${lensId}/lighthouse/configurations`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getLensLighthouse = async (lensId, query) => {
  const { Aa: token } = firebase.auth().currentUser
  const { group, page, limit, sort, filters, currentWindow, selectedColumns, adAccountIds, platform } = query

  const payload = {
    metadata: {
      group_by: group,
      page,
      limit,
      sort,
      attr_window: currentWindow,
      provider: providerKeyMap[platform]
    },
    query: filters,
    selected_columns: selectedColumns,
    query: [
      ...filters,
      [{ key: 'account_id', operation: 'in', value: adAccountIds }]
    ]
  }

  const { data } = await AxiosConfig.post(
    `lenses/${lensId}/lighthouse`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getLensLighthouseChartData = async (lensId, query) => {
  const { Aa: token } = firebase.auth().currentUser
  const { group, page, limit, interval, sort, filters, currentWindow, adAccountIds, platform } = query

  console.log('sort value', sort)

  const payload = {
    metadata: {
      group_by: group,
      page,
      limit,
      interval,
      sort,
      attr_window: currentWindow,
      provider: providerKeyMap[platform]
    },
    query: [
      ...filters,
      [{ key: 'account_id', operation: 'in', value: adAccountIds }]
    ]
  }

  const { data } = await AxiosConfig.post(
    `lenses/${lensId}/lighthouse/targets`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

let lhBreakdownCancelToken = null
const getLensLighthouseBreakdown = async (lensId, query) => {
  const { Aa: token } = firebase.auth().currentUser

  if (lhBreakdownCancelToken) {
    lhBreakdownCancelToken.cancel('New request incoming, cancelling previous one.')
  }

  lhBreakdownCancelToken = axios.CancelToken.source()

  const { group, page, limit, filters, currentWindow, adAccountIds, platform } = query

  const payload = {
    metadata: {
      group_by: group ?? 'ad_name',
      page: page ?? 1,
      limit: limit ?? 10,
      sort: { by: 'spend', order: 'desc' },
      attr_window: currentWindow,
      provider: providerKeyMap[platform]
    },
    query: [
      ...filters,
      [{ key: 'account_id', operation: 'in', value: adAccountIds }]
    ]
  }

  const { data } = await AxiosConfig.post(
    `lenses/${lensId}/lighthouse/breakdown`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  console.log('data', data)
  return data
}

const createGuestInvite = async (lensId, email) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(`/collaborators/${lensId}/invite`, {
    email
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

// Fetch the current user's pending guest invitations for a lens
const getUserLensInvitations = async () => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get('/collaborators/invites', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const getLensInvitationsByLensId = async (lensId) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(`/collaborators/${lensId}/invites`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const handleGuestInvite = async (inviteId, shouldAccept) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(`/collaborators/invite/${inviteId}`, {
    should_accept: shouldAccept
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const revokeGuestInvite = async (inviteId) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.delete(`/collaborators/invite/${inviteId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const getGuestStatus = async () => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get('/collaborators/status', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const refreshLensData = async (lensId) => {
  const { Aa: token } = firebase.auth().currentUser

  const response = await AxiosConfig.post('/lenses/refresh', {
    lens_id: lensId
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return response
}

const getAdComments = async (lensId, adId, params = {}) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    `/lenses/${lensId}/ads/${adId}/comments`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params
    }
  )

  return data
}

const getAllLensComments = async (lensId, params = {}) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    `/lenses/${lensId}/ads/comments`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params
    }
  )

  return data
}

// get each ad account and its spend for a lens
const getMonthlySpend = async (lensId) => {
  const user = firebase.auth()
  if (!user.currentUser) {
    throw new Error('User not authenticated')
  }
  const token = await user.currentUser.getIdToken()
  const { data } = await AxiosConfig.get(`/lenses/${lensId}/accounts/spend`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

// spend back endpoints
const getAutofillDomains = async (lensId) => {
  const user = firebase.auth()
  if (!user.currentUser) {
    throw new Error('User not authenticated')
  }
  const token = await user.currentUser.getIdToken()
  const { data } = await AxiosConfig.get(`/spendback/${lensId}/autofill-domains`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const createSpendBackProperty = async (lensId, payload) => {
  const user = firebase.auth()
  if (!user.currentUser) {
    throw new Error('User not authenticated')
  }
  const token = await user.currentUser.getIdToken()
  const { data } = await AxiosConfig.post(`/spendback/${lensId}/property`, payload, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const connect = async (lensId, accountIds) => {
  const user = firebase.auth()
  if (!user.currentUser) {
    throw new Error('User not authenticated')
  }
  const token = await user.currentUser.getIdToken()
  const { data } = await AxiosConfig.post(`/spendback/${lensId}/connect/byoc`, {
    account_ids: accountIds
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const getSbConnectStatus = async (lensId, platform) => {
  const user = firebase.auth()
  if (!user.currentUser) {
    throw new Error('User not authenticated')
  }
  const token = await user.currentUser.getIdToken()
  const { data } = await AxiosConfig.get(`/spendback/${lensId}/connect/status`, {
    params: { platform },
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const getSbOnboardStatus = async (lensId) => {
  const user = firebase.auth()
  if (!user.currentUser) {
    throw new Error('User not authenticated')
  }
  const token = await user.currentUser.getIdToken()
  const { data } = await AxiosConfig.get(`/spendback/${lensId}/status`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const updateSbOnboardStep = async (lensId, step) => {
  const user = firebase.auth()
  if (!user.currentUser) {
    throw new Error('User not authenticated')
  }
  const token = await user.currentUser.getIdToken()
  const { data } = await AxiosConfig.put(`/spendback/${lensId}/onboard-step`, { step }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const updateDelegateEmail = async (lensId, { email, password, provider, providerOther }) => {
  const user = firebase.auth()
  if (!user.currentUser) {
    throw new Error('User not authenticated')
  }
  const token = await user.currentUser.getIdToken()
  const { data } = await AxiosConfig.put(`/spendback/${lensId}/delegate-email`, {
    email,
    password,
    provider,
    provider_other: providerOther
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const getPixel = async (lensId) => {
  const user = firebase.auth()
  if (!user.currentUser) {
    throw new Error('User not authenticated')
  }
  const token = await user.currentUser.getIdToken()
  const { data } = await AxiosConfig.get(`/spendback/${lensId}/pixel`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const getSavings = async (lensId, { startDate, endDate, platform } = {}) => {
  const user = firebase.auth()
  if (!user.currentUser) {
    throw new Error('User not authenticated')
  }
  const token = await user.currentUser.getIdToken()
  const params = { start_date: startDate, end_date: endDate }
  if (platform) params.platform = platform
  const { data } = await AxiosConfig.get(`/spendback/${lensId}/savings`, {
    params,
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

export default {
  create,
  createTWAccount,
  deleteLens,
  get,
  getAll,
  getAllSidebar,
  getInsightByLens,
  getLensDiscoveryAds,
  getLensStatus,
  getLensStatusV2,
  getAllLensStatusV2,
  abortStatusSearchRequest,
  getTWAccounts,
  getTWAccountsList,
  getTWRedirect,
  getTWSignInURL,
  update,
  getAccountStatus,
  getGuestStatus,
  refreshLensData,

  // V2 (non tw account services)
  getFBAccountsList,
  getLensConnections,

  // V3 (Multi-platform accounts)
  getPlatformAccounts,
  getAllAdAccounts,
  getPlatformAuthURL,

  getPublic,
  // Guest/Collaborator
  Invite: {
    create: createGuestInvite,
    getAll: getUserLensInvitations,
    handle: handleGuestInvite,
    getAllByLensId: getLensInvitationsByLensId,
    revoke: revokeGuestInvite
  },

  // Lighthouse
  Lighthouse: {
    getGroups: getLensLighthouse,
    createConfig: createLighthouseConfig,
    updateConfig: updateLighthouseConfig,
    getAllConfig: getLensLighthouseConfig,
    getChartData: getLensLighthouseChartData,
    getGroupAds: getLensLighthouseBreakdown
  },

  // Ad Comments
  getAdComments,
  getAllLensComments,

  // spend back
  getMonthlySpend,

  SpendBack: {
    getAutofillDomains,
    createProperty: createSpendBackProperty,
    getStatus: getSbOnboardStatus,
    updateOnboardStep: updateSbOnboardStep,
    getConnectStatus: getSbConnectStatus,
    connect,
    updateDelegateEmail,
    getPixel,
    getSavings
  }
}
